import toast from 'react-hot-toast';

const showToast = (message, delay = 2500) => {
  toast.success(message, {
    duration: delay,
    position: 'bottom-center',
    style: {
      background: '#0E1717',
      color: '#FFFFFF',
    },
  });
};

export { showToast };
